// Projects shown on /projects. Each opens in a modal; add a `body` field
// later for the full write-up.
const projects = [
  {
    n: "01",
    name: "Follic",
    kind: "Hair-loss companion · iOS",
    year: "2026",
    tags: ["React Native", "Postgres", "GPT Vision"],
    learned:
      "design your ERD yourself & outline a framework before vibe coding",
  },
  {
    n: "02",
    name: "Agentic Stock Picker",
    kind: "Signals & screening",
    year: "2026",
    tags: ["Python", "Pandas", "EDGAR"],
    learned:
      "priced in",
  },
  {
    n: "02",
    name: "Cloud Cost Explorer",
    kind: "AWS spend, made legible",
    year: "2025",
    tags: ["AWS", "Lambda"],
    learned:
      "most startups don't care about cost (yet) / aws improved their own cost exploer",
  },
  {
    n: "04",
    name: "Voice AI",
    kind: "Configurable SaaS Voice Agents",
    year: "2025",
    tags: ["Twilio", "GPT", "ElevenLabs"],
    learned:
      "Latency is crucial & good models are expensive. ElevenLabs & web sockets",
  },
  {
    n: "05",
    name: "Golf AI",
    kind: "Swing Analysis App",
    year: "2026",
    tags: ["CoreML", "Pose", "TensorFlow"],
    learned:
      "Not everything needs an LLM call",
  },
];

export default projects;
